import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import { chain, RedirectToChangeCustomer } from "@insite/client-framework/Store/Context/Handlers/SignIn";

export interface SignInParameter {
    returnUrl?: string | undefined;
}

addToChainBefore(chain, RedirectToChangeCustomer, props => {
    const returnUrl = props.parameter.returnUrl;
    if (returnUrl?.includes("userfiles/hcp/pdf/")) {
        const homePageUrl = window.location.origin;
        const locationUrl = homePageUrl.concat(returnUrl);
        window.location.href = locationUrl;
    }
});
